import { setSpamListFailed, setSpamListPending, setSpamListSucceed } from './actions';
import { ISpamListRequest } from './types';
import { isShowSubAgentChatListSelector } from '../../selectors';
import { fetchChatsV2, IFetchChatsV2ParamsRequest } from '../../services/chatsList';
import { IChat } from '../../types/chatList';
import { TThunkAction } from '../../types/redux/thunk';
import { ERoute } from '../../types/route';
import { getQueryParamsFetchChatsList } from '../../utils/getQueryParamsFetchChatsList';
import {
  EChatListSection,
  EChatListTrigger,
  getChatListSource,
  getRequestDiagnostics,
} from '../../utils/logging/publicApiDiagnostics';
import { setRoute } from '../route';

/**
 * Получить список заблокированных чатов
 */
export const getSpamChatsV2 =
  (
    { timestampSpam }: ISpamListRequest,
    trigger: EChatListTrigger = EChatListTrigger.Unknown,
  ): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const state = getState();

    const {
      chatList: { chats },
      masterFilters: { selectedSubAgentId },
    } = state;

    const subAgentRealtyUserId = isShowSubAgentChatListSelector(state) ? selectedSubAgentId : undefined;

    dispatch(setSpamListPending({ timestampSpam }));

    const { status, filterBy } = getQueryParamsFetchChatsList(ERoute.Spam);

    const parameters: IFetchChatsV2ParamsRequest = {
      timestamp: timestampSpam,
      subAgentRealtyUserId,
      status,
      filterBy,
    };

    const spamChats = await fetchChatsV2(context, {
      parameters,
      source: getChatListSource(EChatListSection.Spam, trigger),
      diagnostics: getRequestDiagnostics(state, context),
    });

    if (spamChats === null) {
      dispatch(setSpamListFailed());

      return;
    }

    // FIXME: хз, что здесь происходит
    const spamChatsVisible = chats.filter((chat: IChat) => chat.status === 'blocked').length + spamChats.length;

    const filteredChats = spamChatsVisible ? spamChats : [];

    dispatch(setSpamListSucceed(filteredChats));

    /**
     * Ставим активный пункт меню - спам и сбрасываем восстановленный id из архива,
     * чтобы обнулить открытый чат при переходе в архив.
     */
    dispatch(setRoute({ route: ERoute.Spam, cleanRemovedFromSpamChatId: true, cleanRemovedFromArchiveChatId: true }));
  };
